import { render, staticRenderFns } from "./InvoicePurchaseRed.vue?vue&type=template&id=395ca879&scoped=true"
import script from "./InvoicePurchaseRed.vue?vue&type=script&lang=js"
export * from "./InvoicePurchaseRed.vue?vue&type=script&lang=js"
import style0 from "./InvoicePurchaseRed.vue?vue&type=style&index=0&id=395ca879&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395ca879",
  null
  
)

export default component.exports